module.exports = __webpack_public_path__ + "static/media/logo_sigma_realco.b4fe16c1.png";